import "./suche.css";
import { useParams, Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { useEffect, useState, useContext } from "react";
import OpenInNewOutlined from "@material-ui/icons/OpenInNewOutlined";
import { DataContext } from "../../context/DataContext";

const useStyles = makeStyles((theme) => ({
  root: {
    // height:"100%",
    padding: "0px",
    display: "grid",
    gridTemplateColumns: "50% 50%",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "100%",
    },
  },
  griditem: {
    padding: "10px",
    width: "100%",
  },
  section_title: {
    // border: "1px solid #000",
    color: "#fff",
    textTransform: "uppercase",
    fontSize: "14px",
    marginBottom: "10px",
  },
  rounded_corner_right: {
    // border: "1px solid #000",
    backgroundColor: "#ffffff",
    borderRadius: "0px 10px 0px 0px",
    height: "12px",
    width: "100%",
    opacity: 0.8,
  },
  rounded_corner_left: {},
  DA_info_container: {
    // border: "1px solid #f0f",
    width: "100%",
    padding: "2px 10px 8px 10px",
    backgroundColor: "#ffffff",
    color: "#000000",
    opacity: 0.8,
  },

  DA_box: {
    marginBottom: "8px",
    // width: "90%",
    border: "1px solid #fff",
    backgroundColor: "#ffffff",

    padding: "10px",
  },

  DA_box_highlight: {
    border: "1px solid #55ba5e",
    backgroundColor: "#ffffff",
    padding: "10px",

    // width: "100%",
  },
  DA_info_row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "8px",
  },
  DA_info_name: {
    backgroundColor: "#55ba5e",
    color: "#fff",
    padding: "3px",
    width: "70%",
  },
  DA_info_date: {
    color: "#323232",
    fontWeight: "bold",
  },
  DA_info_checkbox: {},
  box_footer: {
    display: "flex",
    justifyContent: "flex-end",
    // fontWeight: "bold",
    padding: "0px 35px",
    alignItems: "center",
    // border: "1px solid #000",
    height: "30px",
    backgroundColor: "#d0e5d9",
    borderRadius: "0px 0px 0px 10px",
    width: "100%",
    // color:"#55ba5e"
  },
}));

export default function Suche() {
  const { appToken, appLoggedInChange, appLoggedIn } = useContext(DataContext);

  const classes = useStyles();

  const [searchString, setSearchString] = useState("");

  const [kontakteData, setKontakteData] = useState({});
  const [kontakteHTML, setKontakteHTML] = useState(<div>Bitte geben Sie Ihre Suche ein</div>);

  const [newsData, setNewsData] = useState({});
  const [newsHTML, setNewsHTML] = useState(<div>Bitte geben Sie Ihre Suche ein</div>);

  const [dateienData, setDateienData] = useState({});
  const [dateienHTML, setDateienHTML] = useState(<div>Bitte geben Sie Ihre Suche ein</div>);
  
  function getSearchKontakte(){
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ` + appToken);
      var requestOptions = {
        method: "GET",
        headers: myHeaders,
      };

    fetch(
      "https://intranet-backend.procuratio.com/api_v2/get_kontakte.php?searchString="+searchString,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => setKontakteData(result.data))
      .catch((error) => console.log("error", error));
  }

  function getDateienSearch(){
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ` + appToken);
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
    };

  fetch(
    "https://intranet-backend.procuratio.com/api_v2/get_files_search.php?searchString="+searchString,
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => setDateienData(result.data))
    .catch((error) => console.log("error", error));
}

  function getNewsSearch(){
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ` + appToken);
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
    };

    fetch(
      "https://intranet-backend.procuratio.com/api_v2/get_news_search.php?searchString="+searchString,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => setNewsData(result.data))
      .catch((error) => console.log("error", error));
  }

  useEffect(() => {
    // Dateh holen
    if(searchString.length>2){

      getNewsSearch()
      getDateienSearch()
    }
  }, [searchString]);

  useEffect(() => {
    // Dateh holen
    getSearchKontakte()

  }, []);

  useEffect(() => {
    console.log('newsData uE',newsData)

    if(searchString.length>2){

      let tmp=Object.values(newsData).map(function(value, index) {
    
      return (<>
      <div className="rounded_corner_right"></div>
      <div className="DA_info_container"
                          >
      <div className="DA_info_row">
        
      <div className="DA_info_name">{//@ts-ignore
      value.nachrichten_headline}</div>
      <div className="DA_info_date">{//@ts-ignore
      value.D}</div>
    </div>
    <div
      className="headline"
      style={{ fontWeight: "bold", fontSize: "14px" }}
    >
      {//@ts-ignore
      value.nachrichten_user} ({value.nachrichten_datum})
      <br />
      <Link
                    to={//@ts-ignore
                      "/nachricht/" + value.nachrichten_id}
                    className="a_header"
                  >LINK</Link>
     
    </div>
    </div>
    <br />
    </>)
    
  })
//@ts-ignore
    setNewsHTML( tmp )
}
else {
  setNewsHTML( <div>Bitte geben Sie mindestens 3 Buchstaben in der Suche an</div>
    )
}
    

  }, [newsData,searchString]); 



  useEffect(() => {
    console.log('dateienData uE',dateienData)
    if(searchString.length>2){
      //@ts-ignore
      let tmp=Object.values(dateienData).map(function(value:String) {
        console.log('dateien value',value)
      return (<>
      <div className="rounded_corner_right"></div>
      <div className="DA_info_container"
                          >
      <div className="DA_info_row">
        
      <div className="DA_info_name">{
      //@ts-ignore
      value
      }</div>
    </div>
    <div
      className="headline"
      style={{ fontWeight: "bold", fontSize: "14px" }}
    >
      <a
                    href={//@ts-ignore
                      "https://intranet-backend.procuratio.com/./"+value }
                    className="a_header"
                    target="_blank"
                  >LINK</a>
     
    </div>
    </div>
    <br />
    </>)
    
  })
//@ts-ignore
    setDateienHTML( tmp )
}
else {
  setDateienHTML( <div>Bitte geben Sie mindestens 3 Buchstaben in der Suche an</div>
    )
}
    

  }, [dateienData]); 
 
  useEffect(() => {
    setNewsHTML( <div>Suche...</div>)
    if(searchString.length>2){
    let tmp=Object.values(kontakteData).map(function(value, index) {

     let value_tmp=JSON.stringify(value).toLowerCase()
      if(value_tmp.includes(searchString.toLowerCase())){

      return (<>
      <div className="rounded_corner_right"></div>
      <div className="DA_info_container"
                          >
      <div className="DA_info_row">
        
      <div className="DA_info_name">Kostenstelle {//@ts-ignore
      value.A}</div>
      <div className="DA_info_date">{//@ts-ignore
      value.D}</div>
    </div>
    <div
      className="headline"
      style={{ fontWeight: "bold", fontSize: "14px" }}
    >
      Ansprechpartner {//@ts-ignore
      value.B} ({value.C})
      <br />
      <br />
      Adresse:<br />
      {//@ts-ignore
      value.E}
      <br />
        {//@ts-ignore
      value.F}
      <br />
        {//@ts-ignore
      value.G+" "+value.H}
      <br />
        {//@ts-ignore
      value.I+" "+value.J}
      <br />
      <br />
      Telefon:
      <a href={//@ts-ignore
      "tel:"+value.K}>
      {//@ts-ignore
      value.K}</a>
      <br />
      Telefon Büro: 
      <a href={//@ts-ignore
      "tel:"+value.L}>
      {//@ts-ignore
      value.L}</a>
      <br />
      Telefon Küche: 
      <a href={//@ts-ignore
      "tel:"+value.M}>
      {//@ts-ignore
      value.M}</a>
      <br />
      Fax: 
      <a href={//@ts-ignore
      "tel:"+value.N}>
      {//@ts-ignore
      value.N}</a>
      <br />
      Handy: 
      <a href={//@ts-ignore
      "tel:"+value.O}>
      {//@ts-ignore
      value.O}</a>
      <br />
      Mail: 
      <a href={//@ts-ignore
      "mailto:"+value.P}>
      {//@ts-ignore
      value.P}</a>
            

    </div>
    </div>
    <br />
    </>)
    
      
    }else {
      return null
    }
  })
//@ts-ignore
    setKontakteHTML( tmp
)
}
else {
  setKontakteHTML( <div>Bitte geben Sie mindestens 3 Buchstaben in der Suche an</div>
    )
}
    

  }, [kontakteData,searchString]); 


  return (
    <>
      <div id="wrapper">
        <div className="container_home">
          <div>
            <input
              type="text"
              placeholder="Bitte geben Sie Ihre Suche ein"
              onChange={(e) => setSearchString(e.target.value)}
              style={{ marginBottom: "40px" }}
            />
          </div>

          <div>
            <div className="section_title" style={{ marginBottom: "10px" }}>
              Kontakte
            </div>
            {kontakteHTML}
          </div>
    
          <div>
          <div>
            <div className="section_title" style={{ marginBottom: "10px" }}>
              Dateien
            </div>
            {dateienHTML
            }
          </div>
            <div className="section_title" style={{ marginBottom: "10px" }}>
              News
            </div>
            {newsHTML}
          </div>
          
          
        </div>
      </div>
    </>
  );
}
